import { render, staticRenderFns } from "./UiGridLayout.vue?vue&type=template&id=3fe67390&scoped=true&"
var script = {}
import style0 from "./UiGridLayout.vue?vue&type=style&index=0&id=3fe67390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe67390",
  null
  
)

export default component.exports